<template>
  <div class="mobile-menu">
    <div class="mobile-menu__header">
      <router-link class="mobile-menu__logo-wrp" :to="vueRoutes.users">
        <img
          class="mobile-menu__logo"
          src="../../../../public/LogoMobile.svg"
          alt="LOGO"
        />
      </router-link>

      <div v-click-outside="ClickOutside" class="mobile-menu__wrapper">
        <button
          type="button"
          class="mobile-menu__button"
          :class="{ activeButton: isClick }"
          @click="toggleClick"
        >
          <div class="mobile-menu__burger">
            <span
              class="mobile-menu__burger-top"
              :class="{ active: isClick }"
            />
            <span
              class="mobile-menu__burger-mid"
              :class="{ active: isClick }"
            />
            <span
              class="mobile-menu__burger-bottom"
              :class="{ active: isClick }"
            />
          </div>
        </button>
        <div class="mobile-menu__body" :class="{ activeMenu: isClick }">
          <div class="mobile-menu__user-info">
            <MobileNav @close-details="isClick = false" />
            <Footer />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileNav from '@/Vue/components/MobileMenu/MobileNav';
import Footer from '@/Vue/common/SideBar/Footer.vue';
import { ref } from 'vue';
import vClickOutside from 'click-outside-vue3';
import { vueRoutes } from '@/router/route-const';
export default {
  name: 'MobileMenu',
  components: { MobileNav, Footer },

  directives: {
    clickOutside: vClickOutside.directive,
  },

  setup() {
    let isClick = ref(false);

    const toggleClick = () => {
      isClick.value = !isClick.value;
    };

    const ClickOutside = () => {
      isClick.value = false;
    };

    return { isClick, toggleClick, ClickOutside, vueRoutes };
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables';
@import '@/scss/mixins';

.mobile-menu {
  display: none;

  &:after {
    position: absolute;
    left: 0;
    right: 0;
    top: 95px;
    content: '';
    //width: 200vw;
    display: block;
    overflow: visible;
    box-sizing: content-box;
    border-bottom: $mobile-menu-border;
  }

  &__header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    //border: $mobile-menu-border;
    //&:after {
    //  content: "";
    //  display: block;
    //  border: $mobile-menu-border;
    //}
  }

  &__logo-wrp {
    display: flex;
    margin-left: 2rem;
  }

  &__button {
    margin: 0 2rem 0 auto;
    padding: 1.22rem 1rem;
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;

    &.activeButton {
      background-color: $mobile-bg;
    }
  }

  &__wrapper {
    position: relative;
  }

  &__body {
    padding: 3rem 3rem 0;
    display: none;
    width: 22.2rem;
    background-color: $mobile-bg;
    position: absolute;
    top: 4.6rem;
    right: 0;
    overflow: auto;
    z-index: 100;

    &.activeMenu {
      display: flex;
    }
  }

  &__passport {
    padding-bottom: 1.8rem;
  }

  &__user-info {
    width: 100%;
  }

  &__footer {
    width: 100%;
    margin: 3.2rem auto 0;
  }

  @include respond-to($tablet) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    //padding-top: 2rem;

    &__burger {
      display: block;
      position: relative;
      width: 3rem;
      height: 2.2rem;
      border-radius: 10px;
    }

    &__burger-top,
    &__burger-mid,
    &__burger-bottom {
      border-radius: 10px;
      background-color: $mobile-bg;
      position: absolute;
      width: 100%;
      height: 0.375rem;
      right: 0;

      &.active {
        background-color: $col-primary;
      }
    }

    &__burger-top {
      top: 0;
    }
    &__burger-mid {
      top: 0.9rem;
    }
    &__burger-bottom {
      bottom: 0;
    }
  }
}
</style>
